import { useCallback, useEffect, useState } from "react";
import { IPageSearch, ITopKeyword } from "../allPageSearch.interface";
import allPageSearchService from "../allPageSearchService";
import { AxiosResponse } from "axios";
import ISearchParams from "../searchParams.interface";

const useGetTopKeywords = (lang?: string, enabled = true) => {
  const [data, setData] = useState<ITopKeyword[]>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return allPageSearchService.getTopKeyWords(lang);
  }, [lang]);

  const transformResponse = useCallback((response: AxiosResponse<ITopKeyword[]>) => {
    if (response) {
      setData(response.data);
    }
  }, []);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [lang]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabled]);

  return { data, error, isLoading, refetch };
};

export default useGetTopKeywords;
